import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../../../ui/custom-table";
import {
  GetCheckinCheckoutapi,
  GetUniqueCheckinCheckoutapi,
} from "../../../api/api";
import { useDispatch } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";

function CheckinCheckoutRecord() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [totalCount, setTotalCount] = useState(0);

  const dispatch = useDispatch();

  const fetchRecord = async (d, name, page, limit) => {
    setLoading(true);
    try {
      const response = await GetUniqueCheckinCheckoutapi(
        d,
        name,
        page + 1,
        limit
      );
      if (response?.data?.status === true) {
        setRecords(response.data.data);
        setTotalCount(response.data.total || 100);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  // GetCheckinCheckoutapiByEmployeeId
  useEffect(() => {
    fetchRecord(
      selectedDate,
      searchTerm,
      pagination.pageIndex,
      pagination.pageSize
    );
  }, [selectedDate, searchTerm, pagination.pageIndex, pagination.pageSize]);

  const handleDateChange = (e) => setSelectedDate(e.target.value);
  const handleSearchChange = (e) => setSearchTerm(e.target.value);
  const handlePaginationChange = (updater) => {
    setPagination((prev) =>
      typeof updater === "function" ? updater(prev) : updater
    );
  };

  const handleExport = () => {
    if (records.length === 0) {
      alert("No records to export.");
      return;
    }

    const exportData = records.map((record) => ({
      Name: record.student_name,
      Status: record.operation,
      CheckIn: record.in_time
        ? new Date(record.in_time).toLocaleString("en-IN")
        : "-",
      CheckOut: record.out_time
        ? new Date(record.out_time).toLocaleString("en-IN")
        : "-",
    }));

    const header = Object.keys(exportData[0]).join(",");
    const rows = exportData.map((row) =>
      Object.values(row)
        .map((value) => `"${String(value).replace(/"/g, '""')}"`)
        .join(",")
    );

    const csvContent = [header, ...rows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "CheckinCheckoutRecords.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "employee_image",
        header: "Employee Image",
        Cell: ({ row }) => {
          const imagePath = row.original.image_dataset_path;
          const imageUrl = imagePath
            ? `https://visionemptrack.greymatterz.com//${imagePath}`
            : "";

          return (
            imageUrl && (
              <img
                src={imageUrl}
                alt="Employee"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            )
          );
        },
      },
      { accessorKey: "employee_name", header: "Employee Name" },
      { accessorKey: "operation", header: "Status" },
      {
        accessorKey: "in_time",
        header: "CheckIn Time",
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value
            ? new Date(value).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
            : "-";
        },
      },
      {
        accessorKey: "out_time",
        header: "CheckOut Time",
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value
            ? new Date(value).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
            : "-";
        },
      },
    ],
    []
  );

  const handleView = (row) => {
    dispatch(
      SetPopupReducerData({
        modalType: "CheckInDettails",
        showModal: true,
        data: row?.employee_id,
      })
    );
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">CheckIn/Checkout Record</h5>
      </div>

      <CustomTable
        columns={columns}
        data={records}
        loading={loading}
        pagination={pagination}
        onPaginationChange={handlePaginationChange}
        rowCount={totalCount}
        selectedDate={selectedDate}
        showActions={true}
        showViewButton={true}
        onView={handleView}
        handleDateChange={handleDateChange}
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
        onExport={handleExport}
        onResetFilters={() => {
          setSelectedDate("");
          setSearchTerm("");
          setPagination({ pageIndex: 0, pageSize: 10 });
        }}
      />
    </>
  );
}

export default CheckinCheckoutRecord;
